import * as cardsApi from '@/network/api/cards/cards.api.js'

/** requests Cards List
@return {promise} - Cards List request
*/
export const requestCardsList = async (context, payload) => {
    const res = await cardsApi.cards(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_CARDS_LIST', data)
    }
    return res
}

/** requests Card Movements
@return {promise} - Card Movements request
*/
export const requestCardMovements = async (context, payload) => {
    const res = await cardsApi.requestCardMovements(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_CARD_MOVEMENTS', { pageNumber: payload.params.pageNumber, data: data })
    }
    return res
}

/** requests Card Description Update
@return {promise} - Card Description Update request
*/
export const updateCardDescription = async (context, payload) => {
    const res = await cardsApi.updateCardDescription(payload)
    if (res) {
        context.commit('UPDATE_CARD_DESCRIPTION', payload)
    }
    return res
}

/** requests Card Movement Detail
@return {promise} - Card Movement Detail request
*/
export const requestMovimentDetail = async (context, payload) => {
    const res = await cardsApi.requestMovimentDetail(payload)
    return res
}

/** requests Card security hidden info for card
@return {promise} - Card security hidden info for card request
*/
export const requestSecurityInfoForCard = async (context, payload) => {
    const res = await cardsApi.requestSecurityInfoForCard(payload)
    return res
}

/* ***********************************************
*                   CLEAR ACTIONS                *
*********************************************** */
export const clearFeatureStates = async (context, payload) => {
    context.commit('CLEAR_FEATURE_STATE')
}
